import { IRawStyle } from "@fluentui/react";
import React from "react";
import { ContentSection, GridRow, GridColumn, LabeledText, ButtonRenderProps } from "sprint-common-web";

import { AspectRatiosDataProvider } from "../../../../../../../common/data/lookup-data-providers/AspectRatiosDataProvider";
import { AspectTypesDataProvider } from "../../../../../../../common/data/lookup-data-providers/AspectTypesDataProvider";
import { CloudVideoTechnical } from "../../../../CloudAssetDetails";
import {
    EditCloudVideoAssetTechnicalAside,
    EditCloudVideoAssetTechnicalAsideProps
} from "./edit/EditCloudVideoTechnicalButtonAside";

interface CloudVideoTechnicalSectionProps {
    technical: CloudVideoTechnical;
    isLoading: boolean;
    style?: IRawStyle;
}

export const CloudVideoTechnicalSection: React.FunctionComponent<CloudVideoTechnicalSectionProps> = (
    props: CloudVideoTechnicalSectionProps
) => {
    const { technical, isLoading } = props;

    const editTechnicalButton: ButtonRenderProps<EditCloudVideoAssetTechnicalAsideProps> = {
        isLabeled: true,
        render: EditCloudVideoAssetTechnicalAside,
        aspectRatioId: technical.aspectRatio?.id,
        aspectTypeId: technical.aspectType?.id
    };

    return (
        <AspectTypesDataProvider>
            <AspectRatiosDataProvider>
                <ContentSection
                    header="Technical"
                    isLoading={isLoading}
                    buttons={[editTechnicalButton]}
                    style={props.style}
                >
                    <GridRow>
                        <GridColumn sm={3}>
                            <LabeledText label="Format" value={technical.format} testId="Format" />
                            <LabeledText label="Encoding" value={technical.encoding} testId="Encoding" />
                            <LabeledText
                                label="Aspect type"
                                value={technical.aspectType?.name}
                                testId="aspect-type-field"
                            />
                        </GridColumn>
                        <GridColumn sm={3}>
                            <LabeledText
                                label="FFProbe aspect ratio"
                                value={technical.fileAspectRatio}
                                testId="ffProbe-aspect-ratio-field"
                            />
                            <LabeledText
                                label="Aspect ratio"
                                value={technical.aspectRatio?.name}
                                testId="aspect-ratio-field"
                            />
                            <LabeledText label="Resolution" value={technical.resolution} testId="resolution-field" />
                        </GridColumn>
                        <GridColumn sm={3}>
                            <LabeledText label="Duration" value={technical.duration} testId="Duration" />
                            <LabeledText label="Framerate" value={technical.framerate} testId="framerate-field" />
                            <LabeledText label="Bit rate" value={technical.videoBitRate} testId="bit-rate-field" />
                        </GridColumn>
                    </GridRow>
                </ContentSection>
            </AspectRatiosDataProvider>
        </AspectTypesDataProvider>
    );
};
